'use client';
import React from 'react';
import { AccountProfile as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (Shared as any).render;

function buildProfile(customer: any) {
  if (!customer) return undefined;
  const md: any = customer.metadata ?? {};
  const primary = (customer.shipping_addresses ?? [])[0] ?? (customer.addresses ?? [])[0];
  const addressStr = primary
    ? [primary.address_1, primary.city, primary.province, primary.postal_code, primary.country_code]
        .filter(Boolean)
        .join(', ')
    : '';

  return {
    firstName: customer.first_name ?? '',
    lastName: customer.last_name ?? '',
    email: customer.email ?? '',
    phone: customer.phone ?? '',
    birthday: md.birthday ?? '',
    address: addressStr,
    newsletter: md.newsletter === true,
    orderNotifications: md.order_notifications !== false,
  };
}

/**
 * Storefront AccountProfile — reads the logged-in customer from Puck
 * context (preferred) or the page, and maps to the shared component's
 * profile shape. Falls back to the shared MOCK in editor preview.
 */
function AccountProfileImpl(props: any) {
  const { context } = usePuckContext() as any;
  const customer = context?.customer;

  if (context?.sampleProfile) {
    return <SharedRender {...props} profile={context.sampleProfile} />;
  }
  if (!customer) {
    return <SharedRender {...props} profile={undefined} />;
  }

  return <SharedRender {...props} profile={buildProfile(customer)} />;
}

export const AccountProfile: any = {
  ...Shared,
  render: (props: any) => <AccountProfileImpl {...props} />,
};
export default AccountProfile;
